function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "\\u2705-Project",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Baner-aplikacja-mobilna",
  transform: "translate(-371.000000, -141.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "d",
  transform: "translate(366.000000, 141.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Safespace",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}), /*#__PURE__*/React.createElement("g", {
  id: "telefon-kopia",
  transform: "translate(4.800000, 0.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.72,0.684 L3.408,0.684 C2.39868187,0.703705537 1.59461144,1.53457831 1.608,2.544 L1.608,20.4 C1.59461144,21.4094217 2.39868187,22.2402945 3.408,22.26 L12.672,22.26 C13.676599,22.2338174 14.4734776,21.4048497 14.46,20.4 L14.46,2.4 C14.4468734,1.44841015 13.6716804,0.684 12.72,0.684 Z",
  id: "Path",
  fill: "#48A9A1",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval",
  fill: "#5C5C5C",
  cx: 7.044,
  cy: 20.856,
  rx: 1,
  ry: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.412,2.868 L2.724,2.868 C2.2603933,2.87429503 1.81847176,3.06535898 1.49630281,3.39879258 C1.17413386,3.73222618 0.998364517,4.1804507 1.008,4.644 L1.008,21.252 C0.998364517,21.7155493 1.17413386,22.1637738 1.49630281,22.4972074 C1.81847176,22.830641 2.2603933,23.021705 2.724,23.028 L11.364,23.028 C11.825509,23.0185504 12.26435,22.8261032 12.583933,22.4930168 C12.9035159,22.1599303 13.0776472,21.7135049 13.068,21.252 L13.068,4.524 C13.068,3.60941645 12.3265835,2.868 11.412,2.868 Z M2.208,4.644 C2.198164,4.49873449 2.24740518,4.35565241 2.34455529,4.24720578 C2.44170539,4.13875915 2.57853133,4.07413841 2.724,4.068 L11.412,4.068 C11.6638418,4.068 11.868,4.27215815 11.868,4.524 L11.868,5.544 L2.268,5.544 L2.208,4.644 Z M11.868,6.744 L11.868,18.744 L2.268,18.744 L2.268,6.744 L11.868,6.744 Z M11.364,21.828 L2.724,21.828 C2.57853133,21.8218616 2.44170539,21.7572409 2.34455529,21.6487942 C2.24740518,21.5403476 2.198164,21.3972655 2.208,21.252 L2.208,19.944 L11.868,19.944 L11.868,21.252 C11.8778728,21.3952931 11.8302514,21.5366153 11.7356686,21.64471 C11.6410857,21.7528047 11.5073355,21.8187642 11.364,21.828 Z",
  id: "Shape",
  fill: "#555150"
})))));

var SvgPhone = function SvgPhone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "24px",
    viewBox: "0 0 15 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Phone.3c4675d4.svg";
export { ForwardRef as ReactComponent };